import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

export interface ErrorContext {
  component?: string;
  action?: string;
  metadata?: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  handleError(error: Error | HttpErrorResponse | string, context?: ErrorContext): void {
    const errorMessage = this.getErrorMessage(error);
    const timestamp = new Date().toISOString();

    // In production, this would send to a monitoring service like Sentry
    // For now, we'll use structured logging
    const logEntry = {
      timestamp,
      message: errorMessage,
      context,
      stack: error instanceof Error ? error.stack : undefined,
      type: this.getErrorType(error)
    };

    // Log to console in development (would be replaced with monitoring service)
    console.error('[ErrorHandler]', logEntry);

    // You can add additional logic here:
    // - Send to analytics
    // - Show user notification
    // - Store in local storage for debugging
  }

  private getErrorMessage(error: Error | HttpErrorResponse | string): string {
    if (typeof error === 'string') {
      return error;
    }

    if (error instanceof HttpErrorResponse) {
      if (error.error?.message) {
        return error.error.message;
      }
      return `HTTP Error ${error.status}: ${error.statusText}`;
    }

    if (error instanceof Error) {
      return error.message;
    }

    return 'Unknown error occurred';
  }

  private getErrorType(error: Error | HttpErrorResponse | string): string {
    if (typeof error === 'string') {
      return 'string';
    }
    if (error instanceof HttpErrorResponse) {
      return 'http';
    }
    if (error instanceof Error) {
      return error.constructor.name;
    }
    return 'unknown';
  }
}
